import React from "react";
import { useContent } from "contexts/contentContext/contentContext.js";
import Button from "components/Elements/Button/Button.js";
import "./BeforePurchaseModal.scss";
import { useModal } from "contexts/modalContext/modalContext.js";
import PurchaseSubUsersModal from "./PurchaseSubUsersModal.js";

const BeforePurchaseModal = (props) => {
    const { getTextByKey } = useContent();
    const { closeModal } = useModal();
    const { setModal } = useModal();


    const openPurchaseSubUsers  = () => {
        closeModal();
        setModal(() => (
            <PurchaseSubUsersModal
                userData={props.userData}
            />
        ));

    }

        return (
            <div className="no-licenses-modal">
                <div className="title">
                    {getTextByKey("no-licenses-title")}
                </div>
                <div className="text">
                    {getTextByKey("no-licenses-text")}
                </div>
                <Button 
                    className="new-button"
                    blank
                    onClick={() => openPurchaseSubUsers()}>
                    {getTextByKey("add-licenses-button-text")}
                </Button>
            </div>

        );
};

export default BeforePurchaseModal;
